import { LocationNumbersService } from '../../../services'

const deleteNumber = async function ({ commit, dispatch, state }, config) {
  const { locationId, numberId, phoneNumber, removeFromTwilio } = config
  try {
    const payload = {
      locationId: locationId,
      numberId: numberId,
      phoneNumber: phoneNumber,
      removeFromTwilio: removeFromTwilio,
    }
    const data = await LocationNumbersService.deleteNumber(payload)

    await dispatch('fetchLocationTwilio', locationId)
    await commit('resetPhoneNumbersPaginated', {
      page: null
    })
    await dispatch('fetchPhoneNumbersFromDBPaginated', {
      companyId: state.company?.company?.id,
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: 1,
        query: '',
      },
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default deleteNumber
